import * as yup from "yup";

export const resetTotpSchema = yup.object().shape({
    email: yup.string().email("Ingrese un email válido").required("Ingrese este campo"),
});
